/**
 * Client-side only. Describes the offline sync state of a record in IndexedDB.
 */
export const SyncState = {
  synced: 'synced',
  pending: 'pending',
  localOnly: 'localOnly',
  failed: 'failed',
  conflict: 'conflict',
} as const;

export type SyncState = (typeof SyncState)[keyof typeof SyncState];
